if (!customElements.get("three-video-modal")) {
  customElements.define(
    "three-video-modal",
    class extends HTMLElement {
      constructor() {
        super();

        this.slides = this.querySelectorAll(".three-products__slide");
        this.next_button = this.querySelector(
          "slideshow-component [name='next']",
        );

        const mobile_query = window.matchMedia("(max-width: 749px)");

        if (mobile_query.matches) {
          //run on load and check if mobile
          // after first video plays, scroll slider to next video

          return;
          this.slides.forEach((slide) => {
            this.addPlayListener(slide);
          });
        }
      }
      addPlayListener(slide) {
        var deferred_media = slide.querySelector("deferred-media");

        if (!deferred_media) return;

        deferred_media.addEventListener(
          "playing",
          (e) => {
            let video = e.target.querySelector("video");

            if (!video) return;

            let hasLoopedOnce = false;
            let hasFired = false;

            video.addEventListener("timeupdate", (e) => {
              if (e.target.currentTime < 0.5) {
                console.log(e.target.currentTime, e);
                if (!hasLoopedOnce) {
                  hasLoopedOnce = true;
                } else {
                  //check if in viewPort
                  var boundary = e.target.getBoundingClientRect();

                  if (boundary.left >= 0 && !hasFired) {
                    //within viewport
                    //go to next slide
                    hasFired = true;
                    this.next_button.click();
                  } else {
                    hasFired = false;
                  }
                }
              }
            });
          },
          { once: true },
        );
      }
    },
  );
}
